<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { accountBlockedMessage } from './accountBlocked';
</script>

<!-- pełnoekranowy komunikat zamiast interfejsu: menu ani mapa nie są renderowane -->
<div class="account-blocked" data-testid="account-blocked-screen">
    <div class="box">
        <div class="header">{$_('Access denied')}</div>
        <div class="message">{$_(accountBlockedMessage)}</div>
    </div>
</div>

<style>
    .account-blocked {
        width: 100vw;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #f7f7f7;
    }
    .box {
        max-width: 520px;
        padding: 30px 40px;
        background-color: white;
        border-radius: 10px;
        box-shadow: 0 6px 24px -12px rgba(0, 0, 0, 0.5);
        text-align: center;
        row-gap: 14px;
        display: flex;
        flex-direction: column;
    }
    .header {
        font-size: 20px;
        font-weight: 600;
        color: var(--analytics-red, #c0392b);
    }
    .message {
        font-size: 15px;
        line-height: 1.5;
        color: #333;
    }
</style>
